import React from 'react';
import { QuoteIcon, AlertTriangleIcon } from 'lucide-react';
export function Testimonials() {
  return <section className="mb-16" data-id="element-271">
      <h2 className="text-2xl font-bold mb-6 text-blue-900" data-id="element-272">
        Margaret's Transformation
      </h2>
      <div className="text-lg mb-8" data-id="element-273">
        <p className="mb-4" data-id="element-274">
          Within weeks, Margaret's life looked completely different:
        </p>
        <ul className="space-y-3 mb-6" data-id="element-275">
          <li className="flex items-start" data-id="element-276">
            <span className="text-blue-500 mr-2" data-id="element-277">•</span>
            <span data-id="element-278">
              She hosted her book club again — this time without a single sneeze
              or embarrassing breakdown.
            </span>
          </li>
          <li className="flex items-start" data-id="element-279">
            <span className="text-blue-500 mr-2" data-id="element-280">•</span>
            <span data-id="element-281">
              She finally slept through the night, waking up refreshed instead
              of congested.
            </span>
          </li>
          <li className="flex items-start" data-id="element-282">
            <span className="text-blue-500 mr-2" data-id="element-283">•</span>
            <span data-id="element-284">
              She cuddled Mr. Mittens on the couch without fear, guilt, or
              wheezing.
            </span>
          </li>
          <li className="flex items-start" data-id="element-285">
            <span className="text-blue-500 mr-2" data-id="element-286">•</span>
            <span data-id="element-287">
              Most importantly, she never had to face the heartbreaking decision
              of rehoming her beloved cat.
            </span>
          </li>
        </ul>
      </div>
      <blockquote className="border-l-4 border-blue-500 pl-4 italic text-xl mb-12" data-id="element-288">
        "DNRx eliminated the airborne allergens and saved both my health and my
        relationship with my cat."
        <footer className="text-lg font-medium mt-2" data-id="element-289">— Margaret</footer>
      </blockquote>
      <div className="flex justify-center mb-8" data-id="element-290">
        <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/u9RUDheNYdtXnqmuTiNYiE/Untitled_%281000_x_700_px%29_%281250_x_700_px%29.png" alt="Collage of happy customers using Petssey DNRx devices in their homes" className="w-3/2 rounded-lg shadow-md" data-id="element-291" />
      </div>
      <h2 className="text-2xl font-bold mb-6 text-blue-900" data-id="element-292">
        Trusted by Cat Parents Across Australian
      </h2>
      <p className="text-lg mb-6" data-id="element-293">
        Margaret isn't alone. Over 1,300 Australian cat owners have already
        discovered how Petssey DNRx makes life with their pets allergy-free —
        and stock keeps selling out.
      </p>
      <p className="text-lg mb-6" data-id="element-294">Here's what real customers are saying:</p>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-8" data-id="element-295">
        <div className="bg-blue-50 p-6 rounded-lg" data-id="element-296">
          <div className="flex items-start gap-4" data-id="element-297">
            <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/5K5Qu7EBoCcZQctMjKfnRL/Facebook_posts_%28100_x_125_px%29.png" alt="Senior woman with glasses holding two cats" className="w-18 h-18 rounded-full object-cover border-2 border-blue-200" data-id="element-298" />
            <div data-id="element-299">
              <QuoteIcon className="text-blue-300 mb-2" size={24} data-id="element-300" />
              <p className="text-lg italic mb-2" data-id="element-301">
                "My respiortory attacks vanished within a week of plugging it in"
              </p>
              <p className="font-medium" data-id="element-302">— Josie, Melbourne</p>
            </div>
          </div>
        </div>
        <div className="bg-blue-50 p-6 rounded-lg" data-id="element-303">
          <div className="flex items-start gap-4" data-id="element-304">
            <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/4FN9FBoxnyLdZ9gMtzLqDy/1.png" alt="Emma from Adelaide" className="w-18 h-18 rounded-full object-cover border-2 border-blue-200" data-id="element-305" />
            <div data-id="element-306">
              <QuoteIcon className="text-blue-300 mb-2" size={24} data-id="element-307" />
              <p className="text-lg italic mb-2" data-id="element-308">
                "Worth every penny. I finally sleep without congestion."
              </p>
              <p className="font-medium" data-id="element-309">— Emma, Adelaide</p>
            </div>
          </div>
        </div>
        <div className="bg-blue-50 p-6 rounded-lg" data-id="element-310">
          <div className="flex items-start gap-4" data-id="element-311">
            <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/wUNjkuAvtc7B2RXB2Jk1bA/2.png" alt="Michael from Brisbane" className="w-18 h-18 rounded-full object-cover border-2 border-blue-200" data-id="element-312" />
            <div data-id="element-313">
              <QuoteIcon className="text-blue-300 mb-2" size={24} data-id="element-314" />
              <p className="text-lg italic mb-2" data-id="element-315">
                "I was ready to rehome my cat. This saved us."
              </p>
              <p className="font-medium" data-id="element-316">— Michael, Brisbane</p>
            </div>
          </div>
        </div>
      </div>
      <div className="flex items-start mb-8" data-id="element-317">
        <AlertTriangleIcon className="text-yellow-500 mr-2 flex-shrink-0" size={24} data-id="element-318" />
        <p className="text-lg" data-id="element-319">
          <strong data-id="element-320">Limited stock available</strong> for Australian customers.
          Most cat parents order 3–6 units for multiple rooms.
        </p>
      </div>
      <div className="flex justify-center" data-id="element-321">
        <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/jovf4ssZ4LBBADJruStVEG/ChatGPT_Image_Sep_2%2C_2025%2C_10_34_43_PM.png" alt="Petssey DNRx device - a sleek white air purifier with blue ambient light and ventilation holes at the bottom" className="w-3/4 rounded-lg shadow-md" data-id="element-322" />
      </div>
    </section>;
}